<div padding [innerHtml]="text()"></div>
